import React, { useEffect, useState } from 'react';
import { TableList, Typography } from 'seagull';
import { useStore, useStoreActions } from "../../../../store/store-context";
import { selectors } from "../../../../store/state-selectors";
import { MapStatusView } from "../MapStatusView";
import styles from "./MapServicesRow.module.scss";
import { serviceTemplateModel } from "../../../../models";
import { getServiceTemplateMapStatus } from "../QboUtils";
import ServiceQboAutocomplete from "../ServiceQboAutocomplete/ServiceQboAutocomplete";
export default function MapServicesRow(props) {
  const {
    serviceTemplate,
    qboItems,
    integratedQboItem,
    onChangeMap,
    testid
  } = props;
  const [selectedOption, setSelectedOption] = useState(integratedQboItem || null);
  const [mapStatus, setMapStatus] = useState(getServiceTemplateMapStatus(serviceTemplate));
  const vendorId = useStore(selectors.user.businessId);
  const userId = useStore(selectors.user.id);
  const {
    logBI
  } = useStoreActions();
  useEffect(() => {
    setMapStatus(getServiceTemplateMapStatus(serviceTemplate));
  }, [serviceTemplate]);
  const onQboItemChange = async qboItemToMap => {
    logBI(qboItemToMap ? 12006 : 12007, {
      vendorId,
      userId
    });
    setMapStatus('mapping');
    setSelectedOption(qboItemToMap);
    try {
      await onChangeMap(serviceTemplate, qboItemToMap === null || qboItemToMap === void 0 ? void 0 : qboItemToMap.id);
    } catch (e) {
      setMapStatus('failedToMap');
    }
  };
  return /*#__PURE__*/React.createElement(TableList.Row, {
    "data-testid": testid,
    items: [{
      value: /*#__PURE__*/React.createElement("div", {
        "data-testid": "service-template"
      }, /*#__PURE__*/React.createElement(Typography, {
        skin: serviceTemplateModel.isDeleted(serviceTemplate) ? 'secondary' : 'standard',
        ellipsis: true
      }, "".concat(serviceTemplate.name).concat(serviceTemplateModel.isDeleted(serviceTemplate) ? ' (Archived)' : '')))
    }, {
      value: /*#__PURE__*/React.createElement("div", {
        "data-testid": "qbo-service",
        className: styles.autocompleteWrapper
      }, /*#__PURE__*/React.createElement(ServiceQboAutocomplete, {
        testid: "qbo-services-modal-autocomplete",
        onQboItemChange: onQboItemChange,
        qboItems: qboItems,
        selectedOption: selectedOption,
        showQboMapPlaceHolder: false
      }))
    }, {
      value: /*#__PURE__*/React.createElement(MapStatusView, {
        mapStatus: mapStatus
      })
    }]
  });
}